import { render, staticRenderFns } from "./PeopleName.vue?vue&type=template&id=e6da98de&scoped=true&"
import script from "./PeopleName.vue?vue&type=script&lang=js&"
export * from "./PeopleName.vue?vue&type=script&lang=js&"
import style0 from "./PeopleName.vue?vue&type=style&index=0&id=e6da98de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6da98de",
  null
  
)

export default component.exports